<script>
import { CellGroup, Cell } from 'vant'
import ImageViewer from './ImageViewer'
import BottomToolbar from './BottomToolbar'
import Organization from '../../tbs/model/to/Organization'
import { QNImageUtil } from '../../utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'organization-basic-info',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell-group': CellGroup,
        'van-cell': Cell,
        'image-viewer': ImageViewer,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        organization: Object,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['edit-organization'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            locale: new Organization
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onEditBtnClick() {
            console.log('onEditBtnClick')
            this.$emit('edit-organization')
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="organization-basic-info">
        <van-cell-group>
            <van-cell :title="locale['organization-name-label']" :value="organization.name"/>
            <image-viewer
                :label="locale['organization-logo-label']"
                :imageUrl="adjustImageSize(organization.logoUrl, 160, 160)"
                :previewImageUrl="adjustImageSize(organization.logoUrl, 750, 750)"
            />
            <van-cell :title="locale['city-region']" :value="organization.area"/>
            <van-cell :title="locale['sport-type']" :value="organization.sportTypesLabel"/>
            <van-cell :title="locale['organization-contact-label']" :value="organization.contact"/>
            <van-cell :title="locale['organization-position-label']" :value="organization.position"/>
        </van-cell-group>
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['edit']"
            @click-main-button="onEditBtnClick"
        />
    </div>
</template>